import { useNavigate } from 'react-router-dom';
import { storage } from '../../services/storageService';
import { StorageKeys } from '../../services/constants/StorageKeys';
import { Routes } from '../../routes/RouteConstants';

/**
 * Where the guest goes after an answer of the email + password sign-in, the way ConfirmBookingPage
 * picks it from Booking.status. `emailVerification` ({ email, purpose }) is kept with the token when
 * a code is on its way, for the code page.
 */
const useAuthNextStep = () => {
  const navigate = useNavigate();

  return (authResponse, emailVerification) => {
    switch (authResponse?.nextStep) {
      case "EMAIL_VERIFICATION_REQUIRED":
        const now = Date.now();
        storage.set(StorageKeys.EMAIL_VERIFICATION, {
          ...emailVerification,
          token: authResponse.token,
          // startedAt stays, sentAt moves with every resend: the request expires from the first.
          startedAt: now,
          sentAt: now,
        });
        navigate(Routes.VERIFY_EMAIL);
        break;
      case "PROFILE_COMPLETION_REQUIRED":
        storage.remove(StorageKeys.EMAIL_VERIFICATION);
        navigate(Routes.COMPLETE_REGISTRATION, { replace: true });
        break;
      case "AUTHENTICATED":
        storage.remove(StorageKeys.EMAIL_VERIFICATION);
        // It sets the flag and goes on to targetRouteBeforeRedirect, as after a Google sign-in.
        navigate(Routes.SUCCESSFUL_AUTH, { replace: true });
        break;
      default:
        break;
    }
  };
};

export default useAuthNextStep;
